export default function SingleUrlValidator({
  imageValidatorUrl,
  handleChangeUrl,
  loadingImageData,
  handleReset,
  imageValidationData = {}, // Provide a default value to avoid undefined
  handleSingleSubmit,
  errorSingleValidaotr,
}) {
  return (
    <>
      <div className="d-flex align-items-center gap-2 mt-2">
        <input
          className="form-control form-control-sm mr-3"
          placeholder="Enter image URL..."
          value={imageValidatorUrl}
          onChange={handleChangeUrl}
        />
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-sm btn-primary mr-3"
            onClick={handleSingleSubmit}
            disabled={loadingImageData}
          >
            {loadingImageData ? "Submitting..." : "Submit"}
          </button>
          <button
            type="button"
            className="btn btn-sm btn-warning mr-3"
            onClick={handleReset}
          >
            Reset
          </button>
        </div>
      </div>
      <div className="text-center mt-3">
        <p>File Path: {imageValidationData?.pathFile || "N/A"}</p>
        {Object.hasOwn(imageValidationData, "exist") && (
          <p>Exists: {imageValidationData.exist ? "true" : "false"}</p>
        )}
        {imageValidationData?.message && (
          <p className="text-danger">Message: {imageValidationData.message}</p>
        )}
        {errorSingleValidaotr && (
          <p className="text-danger">{errorSingleValidaotr}</p>
        )}
      </div>

      {imageValidationData.imageUrl && (
        <img
          src={imageValidationData.imageUrl}
          alt="Validated"
          style={{
            maxWidth: "50%",
            maxHeight: "50%",
            width: "50%",
            height: "50%",
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
          }}
          className="img-fluid"
        />
      )}
    </>
  );
}
